import { render, staticRenderFns } from "./CommonUpdatedLabel.vue?vue&type=template&id=64d33ec4"
import script from "./CommonUpdatedLabel.vue?vue&type=script&lang=js"
export * from "./CommonUpdatedLabel.vue?vue&type=script&lang=js"
import style0 from "./CommonUpdatedLabel.vue?vue&type=style&index=0&id=64d33ec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports